/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Links_Gitlab_LabelInputs */

const en_welcome_links_gitlab_label = /** @type {(inputs: Welcome_Links_Gitlab_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source code`)
};

const fr_welcome_links_gitlab_label = /** @type {(inputs: Welcome_Links_Gitlab_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code source`)
};

const ms_sg2_welcome_links_gitlab_label = /** @type {(inputs: Welcome_Links_Gitlab_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod sumber`)
};

/**
* | output |
* | --- |
* | "Source code" |
*
* @param {Welcome_Links_Gitlab_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_links_gitlab_label = /** @type {((inputs?: Welcome_Links_Gitlab_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Links_Gitlab_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_links_gitlab_label(inputs)
	if (locale === "fr") return fr_welcome_links_gitlab_label(inputs)
	return ms_sg2_welcome_links_gitlab_label(inputs)
});